import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/setTop',
      name: 'setTop',
      component: resolve => require(['./views/setTop.vue'],resolve),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/simpleMessage',
      name: 'simpleMessage',
      component: resolve => require(['./views/simpleMessage.vue'],resolve),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/systemNotifyList',
      name: 'systemNotifyList',
      component:resolve=>require(['./views/systemNotifyList.vue'],resolve),
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/superVip',
      name: 'superVip',
      component:resolve=>require(['./views/superVip.vue'],resolve),
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/testUpload',
      name: 'testUpload',
      component:resolve=>require(['./views/testUpload.vue'],resolve),
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/about',
      name: 'about',
      component:resolve=>require(['./views/About.vue'],resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/TabAbout',
      name: 'TabAbout',
      component:resolve=>require(['./views/TabAbout.vue'],resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/mes',
      name: 'mes',
      component:resolve=>require(['./views/Mes.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/noticeList',
      name: 'noticeList',
      component:resolve=>require(['./views/noticeList.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/sendMessage',
      name: 'sendMessage',
      component:resolve=>require(['./views/sendMessage.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/errorReport',
      name: 'errorReport',
      component:resolve=>require(['./views/errorReport.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path:"/shopList",
      name:"shopList",
      component:resolve=>require(['./views/shopList.vue'],resolve),
      meta:{
        keepAlive: true
      }
    },
    {
      path:"/shopDetailInfo",
      name:"shopDetailInfo",
      component:resolve=>require(['./views/shopDetailInfo.vue'],resolve),
      meta:{
        keepAlive: false
      }
    },
    {
      path:"/addShop",
      name:"addShop",
      component:resolve=>require(['./views/addShop.vue'],resolve),
      meta:{
        keepAlive: false
      }
    },
    {
      path:"/continuePay",
      name:"continuePay",
      component:resolve=>require(['./views/continuePay.vue'],resolve),
      meta:{
        keepAlive: false
      }
    },
    {
      path:"/updateShopInfo",
      name:"updateShopInfo",
      component:resolve=>require(['./views/updateShopInfo.vue'],resolve),
      meta:{
        keepAlive: false
      }
    },
    {
      path: '/read',
      name: 'read',
      component:resolve=>require(['./views/Read.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/post',
      name: 'post',
      component:resolve=>require(['./views/PostMessage.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/post2',
      name: 'post2',
      component:resolve=>require(['./views/postMessage2.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/mycenter',
      name: 'mycenter',
      component:resolve=>require(['./views/MyCenter.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/hasSaveShop',
      name: 'hasSaveShop',
      component:resolve=>require(['./views/hasSaveShop.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/hasSaveGoodsList',
      name: 'hasSaveGoodsList',
      component:resolve=>require(['./views/hasSaveGoodsList.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/myPushMsg',
      name: 'myPushMsg',
      component:resolve=>require(['./views/myPushMsg.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/mangerMyShop',
      name: 'mangerMyShop',
      component:resolve=>require(['./views/mangerMyShop.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/result',
      name: 'result',
      component:resolve=>require(['./views/result.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/result2',
      name: 'result2',
      component:resolve=>require(['./views/result2.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/getToken',
      name: 'getToken',
      component:resolve=>require(['./views/GetToken.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/helpPage',
      name: 'helpPage',
      component:resolve=>require(['./views/HelpPage.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/tips',
      name: 'tips',
      component:resolve=>require(['./views/Tips.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/clearLocal',
      name: 'clearLocal',
      component:resolve=>require(['./views/ClearLocal.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/postSuc',
      name: 'postSuc',
      component:resolve=>require(['./views/PostSuc.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/articleDetail',
      name: 'articleDetail',
      component:resolve=>require(['./views/ArticleDetail.vue'],resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/',
      redirect: '/home',
      meta: {
        keepAlive: false
      }
    }
    
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
  
});
router.beforeEach((to, from, next) => {
  setTimeout(() => { 
      let _hmt = _hmt || [];
      (() => {
        document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?5b8fa398d6e0f0741ba9700a24014ff1";
        hm.id = "baidu_tj"
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
  }, 50);
  
  next();
  
});
router.afterEach((to, from) => {
  const u = navigator.userAgent.toLowerCase()
  if(u.indexOf("like mac os x") < 0 || u.match(/MicroMessenger/i) != 'micromessenger' || u.match(/WebP/i) == "webp") return
  if (window.location.href.indexOf(to.fullPath) < 0) {
    
  }
});


export default  router;